import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

interface Props {
  label: string;
  count: number;
}

export const UITabItemLabel: FC<Props> = ({ label, count }) => {
  return (
    <Stack direction='row' alignItems='center' spacing={1}>
      <Typography>{label}</Typography>

      <Box
        sx={{
          bgcolor: "rgba(230, 241, 255, 1)",
          color: "rgba(11, 19, 112, .5)",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 10,
          ml: 1,
        }}
      >
        {count}
      </Box>
    </Stack>
  );
};
